import React from "react";
import { Link } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { elakayAutoText } from "../pageInside/dataElakay";
import "./FloatingEmailInboxIcon.css";

// Floating Email Inbox icon (spec §12) -- modeled directly on
// FamilyErrorDiagnostics.jsx's own floating pill/badge/click/responsive
// behavior (see FloatingEmailInboxIcon.css's header comment), but a fully
// independent component: never modifies FamilyErrorDiagnostics itself.
//
// Show/hide rule (spec, absolute): unreadCount === 0 -> the icon is
// COMPLETELY hidden (return null), not just badge-less -- unlike the Bug
// icon (Family-gated) or the Trash button (always shown once it applies),
// this one is unread-count-gated only. `infoSource.unreadEmailCount`
// mirrors the exact `trashCount` plumbing convention already established
// in Routes.js/Layout.js (see that file's own header comment for why).
const FloatingEmailInboxIcon = ({ infoSource }) => {
  const unreadCount = Number(infoSource?.unreadEmailCount) || 0;
  if (unreadCount <= 0) return null;

  return (
    <Link
      to="/email-inbox"
      className="email-inbox-floating-button"
      title={elakayAutoText("h_emk_inbox_floating_title", "Email Inbox")}
      aria-label={`${elakayAutoText("h_emk_inbox_floating_title", "Email Inbox")} (${unreadCount})`}
    >
      <MdEmail />
      <span>{unreadCount}</span>
    </Link>
  );
};

export default FloatingEmailInboxIcon;
